"use client";
export function enableKeyOnDisabledKeys(keyReactState, key) {
    const [keyState, setKeyState] = keyReactState;
    setKeyState(keyState.filter((value) => value !== key));
}
export function disableKeyOnDisabledKeys(keyReactState, key) {
    const [keyState, setKeyState] = keyReactState;
    if (!keyState.find((value) => key === value)) {
        setKeyState([...keyState, key]);
    }
}
export const localeMetadataArray = [
    { locale: "en", fullLocale: "en-US", paymentLocale: "en_US", displayName: "English" },
    { locale: "es", fullLocale: "es-ES", paymentLocale: "es_ES", displayName: "Español" },
    { locale: "pseudo", fullLocale: "en-US", paymentLocale: "en_US", displayName: "Pseudo" }
];
export const localeMetadataMap = new Map(localeMetadataArray.map((lm) => [lm.locale, lm]));
export function getLocaleDisplayName(locale) {
    return (localeMetadataMap.get(locale)?.displayName);
}
export function getLocaleFullLocale(locale) {
    return (localeMetadataMap.get(locale)?.fullLocale);
}
export function getLocalePaymentLocale(locale) {
    return (localeMetadataMap.get(locale)?.paymentLocale);
}
export function getLocaleFromFullLocale(fullLocale) {
    return (fullLocale.split("-")[0]);
}
export function getPaymentLocaleFromFullLocale(fullLocale) {
    return (localeMetadataMap.get(getLocaleFromFullLocale(fullLocale))?.paymentLocale);
}
export function isNumber(str) {
    return (!isNaN(Number(str)) && !isNaN(parseFloat(str)));
}
